import { render, staticRenderFns } from "./MobileCore.vue?vue&type=template&id=98c680de&scoped=true&"
import script from "./MobileCore.vue?vue&type=script&lang=js&"
export * from "./MobileCore.vue?vue&type=script&lang=js&"
import style0 from "./MobileCore.vue?vue&type=style&index=0&id=98c680de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c680de",
  null
  
)

export default component.exports